var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isDeveloperModel)?_c('NavHome'):_c('NavDeveloper'),_c('div',{staticClass:"app-container"},[_c('router-view')],1),(!_vm.isDeveloperModel && false)?_c('FooterBase'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }